import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/healthInsuranceQualificationConfirmation/index'
import {Create} from 'pages/withAuth/adminPage/procedures/healthInsuranceQualificationConfirmation/create'
import {HealthInsuranceQualificationConfirmationFlow} from 'pages/withAuth/adminPage/procedures/healthInsuranceQualificationConfirmation/flow'

export const HealthInsuranceQualificationConfirmationRoutes: RouteParams[] = [
  {
    key: 'health_insurance_qualification_confirmation',
    path: WITH_AUTH_ADMIN_PATHS.HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'health_insurance_qualification_confirmation/create',
    path: WITH_AUTH_ADMIN_PATHS.HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION.CREATE,
    component: Create,
    exact: true,
  },
  {
    key: 'health_insurance_qualification_confirmation/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION.FLOW,
    component: HealthInsuranceQualificationConfirmationFlow,
    exact: true,
  },
]
